import { Check } from "lucide-react";

const ITEMS = [
  "No platform credentials required",
  "No automated submissions",
  "No direct platform integrations",
  "No account access",
  "No guarantees of outcomes",
  "Human-reviewed operational workflows only",
  "Educational and decision-support tooling only",
];

/**
 * ComplianceDisclaimer — recurring trust block used on Home, Products, Pricing.
 * Variants:
 *  - default: light card with checklist
 *  - subtle:  inline, smaller, for in-section placement
 */
export default function ComplianceDisclaimer({ variant = "default", title = "How Lulo Software products operate" }) {
  if (variant === "subtle") {
    return (
      <div data-testid="compliance-disclaimer-subtle" className="rounded-xl border border-slate-200 bg-[#F9FAFB] p-5">
        <p className="text-xs font-semibold uppercase tracking-wider text-slate-500">Operational principles</p>
        <ul className="mt-3 grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-2 text-sm text-slate-700">
          {ITEMS.map((t) => (
            <li key={t} className="flex items-start gap-2">
              <Check size={15} className="mt-1 shrink-0 text-[#2563EB]" />
              <span>{t}</span>
            </li>
          ))}
        </ul>
      </div>
    );
  }

  return (
    <section data-testid="compliance-disclaimer" className="border-t border-slate-200 bg-white">
      <div className="lulo-container py-16 lg:py-20">
        <div className="max-w-3xl">
          <p className="text-xs font-semibold uppercase tracking-wider text-[#2563EB]">Operational principles</p>
          <h2 className="mt-2 text-2xl sm:text-3xl font-semibold tracking-tight text-[#0A2540]">
            {title}
          </h2>
          <p className="mt-3 text-slate-600 leading-7">
            Every Lulo Software product is built as decision-support tooling, not
            decision-replacement. The same operational principles apply across the
            portfolio.
          </p>
        </div>
        <ul className="mt-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-3 text-[15px] text-slate-700">
          {ITEMS.map((t) => (
            <li key={t} className="flex items-start gap-2.5">
              <Check size={16} className="mt-1 shrink-0 text-[#2563EB]" />
              <span>{t}</span>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
